import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';

import { translate } from 'components/translate';
import { toJS } from 'mobx';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import {
  userDataPropType,
  commentDataProptype
} from 'modules/community/commentList/DataPropType';
import { ClassesService } from 'modules/content';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import BulkActionModal from './BulkActionModal';
import CommentListHeader from './CommentListHeader';
import CommentListTable from './CommentListTable';

import {
  COMMENT_STATUS_AS_OBJECT,
  partitionOrphanPagesFromModules
} from '../helpers';

const label = {
  approve: 'general.approve',
  disapprove: 'general.disapprove',
  spam: 'general.spam'
};
const modal = { open: true, close: false };
const macroType = 'dispatchMacro';

@inject((stores) => ({
  activedTab: stores.CommunityStore.activedTab,
  comments: stores.CommunityStore.comments,
  hash: stores.UserStore.hash,
  membershipClass: stores.CommunityStore.membershipClass,
  selectAll: stores.CommunityStore.selectAll,
  status: stores.CommunityStore.status,
  usersData: stores.CommunityStore.usersData,
  pagesAndModules: toJS(stores.CommunityStore.pagesAndModules)
}))
@observer
@withRouter
@translate()
export default class CommentList extends Component {
  static propTypes = {
    activedTab: PropTypes.number,
    commentStatusList: PropTypes.array,
    comments: MobxPropTypes.observableArrayOf(
      PropTypes.shape(commentDataProptype)
    ),
    dataTableParams: PropTypes.object,
    fetchCommentsData: PropTypes.func,
    fetchUsers: PropTypes.func,
    hash: PropTypes.string,
    history: PropTypes.object,
    loading: PropTypes.bool,
    membershipClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChangeSort: PropTypes.func,
    selectAll: PropTypes.bool,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    pagesAndModules: PropTypes.array,
    t: PropTypes.func,
    updateTab: PropTypes.func,
    usersData: PropTypes.shape(userDataPropType)
  };

  state = {
    actionModal: false,
    membershipClassField: {
      open: false
    },
    bulkActionsField: {
      open: false
    },
    classesList: [],
    notificationsMacros: [],
    notificationsChecked: [],
    selectAll: false,
    massActionsType: '',
    macroId: '',
    activedTab: this.props.activedTab,
    commentStatus: null
  };

  constructor(props) {
    super(props);

    this.toogleModal = this.toogleModal.bind(this);
    this.toogleModalMacro = this.toogleModalMacro.bind(this);
    this.commentStatusMassUpdate = this.commentStatusMassUpdate.bind(this);
    this.dispatchMacro = this.dispatchMacro.bind(this);
    this.setClass = this.setClass.bind(this);
    this.setCommentStatus = this.setCommentStatus.bind(this);
    this.setPagesAndModules = this.setPagesAndModules.bind(this);

    const { t } = props;

    this.COMMENT_STATUS_BY_ID = COMMENT_STATUS_AS_OBJECT(t);
  }

  async componentDidMount() {
    const { activedTab, commentStatusList, status: statusProp } = this.props;

    let { commentStatus } = this.state;

    const classesList = await ClassesService.getSelectFormatedClasses();
    const notificationsMacros = await CommunityService.getNotificationMacros();

    if (!statusProp) {
      const status = commentStatusList[activedTab];

      commentStatus = status;
      CommunityService.setData({ status });
    }

    this.setState({
      classesList,
      notificationsMacros,
      activedTab,
      commentStatus
    });
  }

  infoAlertMessage(action) {
    const { t } = this.props;

    if (action) {
      return UiService.setAlertInfo(t('mass_actions_success_message'), {
        data: { action }
      });
    }

    return UiService.setAlertInfo(t('community.macro_success_message'));
  }

  async dispatchMacro() {
    const { macroId, commentsChecked } = this.state;
    const { hash: userId } = this.props;

    const data = {
      typeId: macroId,
      comments: [
        ...CommentListService.getCommentsDataToSend({
          items: commentsChecked,
          userId
        })
      ]
    };

    const response = await CommunityService.dispatchMacro(data);

    if (response) {
      this.infoAlertMessage();
    }

    this.toogleModalMacro(modal.close);
  }

  async setClass(membershipClass) {
    const { fetchCommentsData, dataTableParams } = this.props;
    const newDataTableParams = { ...dataTableParams };

    CommunityService.setDataTableParamsPagination(newDataTableParams, 0);
    CommunityService.setData({ membershipClass, page: 0 });

    await fetchCommentsData(CommunityService.commentListParams);
  }

  async setPagesAndModules(pagesAndModules) {
    const { pages, modules } = partitionOrphanPagesFromModules(
      pagesAndModules || {}
    );

    const { fetchCommentsData, dataTableParams } = this.props;
    const newDataTableParams = { ...dataTableParams };

    CommunityService.setDataTableParamsPagination(newDataTableParams, 0);
    CommunityService.setData({
      pagesAndModules,
      pageId: pages,
      moduleId: modules,
      page: 0
    });

    await fetchCommentsData(CommunityService.commentListParams);
  }

  async setCommentStatus(status) {
    const { fetchCommentsData, dataTableParams } = this.props;
    const newDataTableParams = { ...dataTableParams };

    CommunityService.setDataTableParamsPagination(newDataTableParams, 0);
    CommunityService.setData({ status: status.value, page: 0 });

    await fetchCommentsData(CommunityService.commentListParams);
  }

  async commentStatusMassUpdate(status, action) {
    const {
      commentsChecked = [],
      selectAll = false,
      isAnyCommentChecked = false
    } = this.commentsChecked || {};

    if (isAnyCommentChecked) {
      const response = await CommunityService.commentStatusMassUpdate(
        CommentListService.getCommentsUpdateData(
          selectAll,
          commentsChecked,
          status
        )
      );

      if (response) {
        this.infoAlertMessage(action);
      }

      this.toogleModal(modal.close);
    }
  }

  toogleModal(actionModal, massActionsType = '', macroId = '') {
    const {
      commentsChecked = [],
      selectAll = false,
      isAnyCommentChecked = false
    } = this.commentsChecked || {};

    if (isAnyCommentChecked) {
      this.setState({
        actionModal,
        open: false,
        commentsChecked,
        selectAll,
        massActionsType,
        macroId
      });
    }
  }

  toogleModalMacro(actionModal, macroId) {
    this.toogleModal(actionModal, macroType, macroId);
  }

  get commentsChecked() {
    const { t, comments = [], selectAll } = this.props;

    const commentsChecked = comments.filter((item) => item._checked);
    const isAnyCommentChecked = selectAll || commentsChecked.length;

    if (!isAnyCommentChecked) {
      return UiService.setAlertWarning(
        t('community.mass_actions_warning_select_notifications')
      );
    }

    return { commentsChecked, selectAll, isAnyCommentChecked };
  }

  get toogleDispatcher() {
    const { massActionsType } = this.state;

    return massActionsType === macroType
      ? this.toogleModalMacro
      : this.toogleModal;
  }

  render() {
    const {
      fetchCommentsData,
      fetchUsers,
      onChangeSort,
      commentStatusList,
      activedTab,
      usersData,
      comments = [],
      loading,
      membershipClass,
      status,
      pagesAndModules
    } = this.props;
    const { actionModal, massActionsType, classesList, notificationsMacros } =
      this.state;

    return (
      <Fragment>
        <CommentListHeader
          key={activedTab}
          modal={modal}
          label={label}
          membershipClass={membershipClass}
          classesList={classesList}
          setClass={this.setClass}
          notificationsMacros={notificationsMacros}
          setCommentStatus={this.setCommentStatus}
          pagesAndModules={pagesAndModules}
          setPagesAndModules={this.setPagesAndModules}
          commentStatusList={commentStatusList}
          commentStatus={this.COMMENT_STATUS_BY_ID[status]}
          toogleModal={this.toogleModal}
          toogleModalMacro={this.toogleModalMacro}
          fetchCommentsData={fetchCommentsData}
          fetchUsers={fetchUsers}
          activedTab={activedTab}
          usersData={usersData}
        />

        <CommentListTable
          fetchCommentsData={fetchCommentsData}
          comments={comments}
          onChangeSort={onChangeSort}
          label={label}
          classesList={classesList}
          loading={loading}
          activedTab={activedTab}
        />

        {actionModal && (
          <BulkActionModal
            label={label}
            modal={modal}
            massActionsType={massActionsType}
            toogleModal={this.toogleDispatcher}
            commentStatusMassUpdate={this.commentStatusMassUpdate}
            dispatchMacro={this.dispatchMacro}
            field="bulkActionsField"
          />
        )}
      </Fragment>
    );
  }
}
